import React from 'react';
import Notifications from './Topbar/Notifications';
import Search from './Topbar/Search';
import UserMenu from './Topbar/UserMenu';

const Topbar: React.FC = () => {
  return (
    <div className="relative z-10 flex-shrink-0 flex h-16 bg-white shadow">
      <button className="px-4 border-r border-gray-200 text-gray-500 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500 md:hidden">
        <span className="sr-only">Open sidebar</span>
        {/* Heroicon name: outline/menu-alt-2 */}
        <svg
          className="h-6 w-6"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          aria-hidden="true"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M4 6h16M4 12h16M4 18h7"
          />
        </svg>
      </button>
      <div className="flex-1 px-4 flex justify-between">
        <div className="flex-1 flex">
          <Search />
        </div>
        <div className="ml-4 space-x-4 flex items-center md:ml-6">
          <Notifications />

          <UserMenu />
        </div>
      </div>
    </div>
  );
};

export default Topbar;
